exports.img_ = require('gatsby-image').default